import React from 'react';

import type { Nullable } from '@clearverify/types';

import { useUserByIdQuery } from 'src/api';

export const useUser = (userId: Nullable<string>) => {
  const { data, loading } = useUserByIdQuery({
    variables: {
      id: userId || '',
    },
    skip: !userId,
  });

  const user = React.useMemo(() => data?.user, [data?.user]);

  return { user, loading };
};
